import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["connectDropTarget"];
import { forwardRef } from 'react';
import { DropTarget } from 'react-dnd-compat';
// @ts-expect-error ts-migrate(7016) FIXME: Could not find a declaration file for module 'cust... Remove this comment to see the full error message
import SharedDragDropContext from 'customer-data-ui-utilities/dnd/SharedDragDropContext';
import ResizableEditorPreview from './ResizableEditorPreview';
import { Flex } from 'foundations-components/components/Flex';
import styled from 'foundations-theming/utils';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
// The first child of connectDropTarget must be a primitive element, so styling needs to come from here
const StyledSpan = styled.span.withConfig({
  displayName: "ResizableThreadViewWrapper__StyledSpan",
  componentId: "sc-17mummm-0"
})(["position:relative;height:100%;> div:first-child{height:100%;}"]);
const TWENTY_PERCENT_OF_WINDOW = window.innerHeight * 0.2;
const MIN_HEIGHT_OF_EDITOR_COMPONENTS = 250;
// the minimum height should be the larger between 20% of screen height or the minimum required space for the editor components
export const minEditorHeight = Math.max(TWENTY_PERCENT_OF_WINDOW, MIN_HEIGHT_OF_EDITOR_COMPONENTS);

// max is 75% of the approximate height of the window height
export const getMaxEditorHeight = () => window.innerHeight * 0.75;
export const DRAG_TYPE = 'thread-view-resize';
export const RESIZABLE_REPLY_EDITOR_ID = 'RESIZABLE_REPLY_EDITOR_ID';
const ResizableThreadViewColumn = /*#__PURE__*/forwardRef((props, ref) => {
  const {
      connectDropTarget
    } = props,
    rest = _objectWithoutPropertiesLoose(props, _excluded);
  return /*#__PURE__*/_jsx(StyledSpan, {
    children: connectDropTarget(
    /*#__PURE__*/
    // @ts-expect-error ts-migrate(2322) FIXME: Type 'ForwardedRef<unknown>' is not assignable to ... Remove this comment to see the full error message
    _jsxs("div", {
      ref: ref,
      children: [/*#__PURE__*/_jsx(Flex, Object.assign({
        alignItems: "stretch",
        flexDirection: "column",
        blockSize: "100%",
        overflow: "auto"
      }, rest)), /*#__PURE__*/_jsx(ResizableEditorPreview, Object.assign({}, rest, {
        maxEditorHeight: getMaxEditorHeight(),
        minEditorHeight,
        windowHeight: window.innerHeight
      }))]
    }))
  });
});
ResizableThreadViewColumn.displayName = 'ResizableThreadViewColumn';
const DropColumn = DropTarget(DRAG_TYPE, {
  drop: (__props, monitor) => {
    const item = monitor.getItem();
    const delta = monitor.getDifferenceFromInitialOffset().y;
    const newHeightWithinBounds = Math.min(getMaxEditorHeight(), Math.max(minEditorHeight, Math.round(item.height - delta)));
    item.setHeight(newHeightWithinBounds);
  }
}, () => ({}))(ResizableThreadViewColumn);
export default SharedDragDropContext()(DropColumn);